import {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {addCustomRecipientMessage} from '~/CreateFabricGreetingCard/api/recipientMessages';
import {
  RECIPIENT_CARD_SELECTED,
  selectRecipientMessage,
  UPDATE_INDIVIDUAL_MESSAGE,
} from '~/CreateFabricGreetingCard/reducers/recipientsMessage';
import {MessageInput} from '~/CreateFabricGreetingCard/routes/RecipientsMessage/components//MessageInput/MessageInput';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {EyeIcon} from '~library/svg/EyeIcon';
import {tanzanite} from '~libSass/base/_exports.sass';

import './IndividualMessage.sass';

export const SingleRecipientPage = ({guest, isMobile, onPreview}) => {
  const recipientMessage = useSelector(selectRecipientMessage(guest?.guest_id));

  const dispatch = useDispatch();

  if (!guest) return null;

  useEffect(() => {
    dispatch({
      type: RECIPIENT_CARD_SELECTED,
      payload: guest.guest_id,
    });
    if (!recipientMessage) {
      dispatch({
        type: UPDATE_INDIVIDUAL_MESSAGE,
        payload: {[guest.guest_id]: recipientMessage || ''},
      });
    }
  }, [guest.guest_id, dispatch, recipientMessage]);

  const onMessageChange = useCallback(
    (message) => {
      dispatch({
        type: UPDATE_INDIVIDUAL_MESSAGE,
        payload: {[guest.guest_id]: message},
      });
    },
    [dispatch, guest.guest_id]
  );

  const onDoneMessageClick = useCallback(() => {
    dispatch(addCustomRecipientMessage([guest.guest_id]));
  }, [dispatch, guest.guest_id]);

  return (
    <div className="individual-message">
      <div className="individual-message__header">
        <Typography variant="paragraph3" className="individual-message__guest" color="charcoal">
          Add a message
        </Typography>
        {isMobile && (
          <Button
            type="button"
            variant="transparent"
            className="individual-message__header__preview-button"
            data-qa-id="preview-btn"
            onClick={onPreview}
          >
            <EyeIcon color={tanzanite} ratio={0.563} /> Preview
          </Button>
        )}
      </div>
      <MessageInput
        dataQaId="message-input"
        message={recipientMessage}
        onMessageChange={onMessageChange}
        onDoneClick={onDoneMessageClick}
        initialState={!recipientMessage}
      />
    </div>
  );
};
